import React, { useEffect } from 'react';
import styles from './curso_marjorie_lashdesign.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const WHATSAPP_NUMBER = '5564993010303';

const SOBRE_O_CURSO = [
    'Três dias de formação teórica e prática',
    'Estudo da apostila, com 20 módulos',
    'Demonstração da técnica em uma modelo',
    'Treinos em bonecos e em 2 modelos',
    'Certificado impresso',
    'Suporte pós-curso com acompanhamento online de 1 ano',
];

const PAGAMENTO = [
    'À vista, Pix ou parcelado no cartão de crédito, da forma que a aluna preferir',
    'Entrada de R$ 500 e o restante após a finalização do curso',
    'Ou pagamento total do valor, se preferir',
];

const CURSOS = [
    {
        nome: 'Lash Start',
        preco: 'R$ 1.300',
        extra: null as string | null,
        destaque: false,
    },
    {
        nome: 'Lash Start Pro',
        preco: 'R$ 1.800',
        extra: 'Kit de materiais completo incluso',
        destaque: true,
    },
];

const Curso_marjorie_lashdesign: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const openWhatsApp = (curso?: string) => {
        const text = curso
            ? `Olá! Vim pelo site e gostaria de informações sobre o Curso ${curso}.`
            : 'Olá! Vim pelo site e gostaria de informações sobre os cursos de Lash Design.';
        window.open(
            `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`,
            '_blank'
        );
    };

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.curso_marjorie_lashdesign}>
                <div className={styles.header}>
                    <Link to="/marjorie_lashdesign" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h2>Curso</h2>
                </div>

                <div className={styles.hero}>
                    <img
                        src={require('./src/curso.png')}
                        alt="Curso de Lash Design"
                        className={styles.heroImage}
                    />
                </div>

                <div className={styles.content}>
                    <section className={styles.section}>
                        <p className={styles.eyebrow}>Extensão de cílios</p>
                        <p className={styles.lead}>Curso Lash Start</p>
                        <p className={styles.highlight}>
                            Duas opções de curso. Escolha a que melhor combina com o seu orçamento:
                            Lash Start ou Lash Start Pro, com kit de materiais completo.
                        </p>
                    </section>

                    <section className={styles.section}>
                        <h3 className={styles.sectionTitle}>Sobre o curso</h3>
                        <ul className={styles.list}>
                            {SOBRE_O_CURSO.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </section>

                    <section className={styles.section}>
                        <h3 className={styles.sectionTitle}>Escolha o seu formato</h3>
                        <div className={styles.courseCards}>
                            {CURSOS.map((curso) => (
                                <article
                                    key={curso.nome}
                                    className={`${styles.courseCard} ${
                                        curso.destaque ? styles.courseCardPro : ''
                                    }`}
                                >
                                    {curso.destaque ? (
                                        <span className={styles.courseBadge}>Incluso o kit</span>
                                    ) : null}
                                    <h4 className={styles.courseName}>{curso.nome}</h4>
                                    <span className={styles.coursePrice}>{curso.preco}</span>
                                    {curso.extra ? (
                                        <p className={styles.courseExtra}>{curso.extra}</p>
                                    ) : null}
                                    <button
                                        type="button"
                                        className={styles.courseButton}
                                        onClick={() => openWhatsApp(curso.nome)}
                                    >
                                        Quero o {curso.nome}
                                    </button>
                                </article>
                            ))}
                        </div>
                    </section>

                    <section className={styles.section}>
                        <h3 className={styles.sectionTitle}>Formas de pagamento</h3>
                        <ul className={styles.list}>
                            {PAGAMENTO.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </section>

                    <section className={styles.ctaSection}>
                        <p className={styles.ctaTitle}>Garanta sua vaga</p>
                        <p className={styles.ctaText}>
                            Fale no WhatsApp para tirar dúvidas e reservar com a entrada de R$ 500.
                        </p>
                        <button type="button" className={styles.ctaButton} onClick={() => openWhatsApp()}>
                            Quero garantir minha vaga
                        </button>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Curso_marjorie_lashdesign;
